module.exports = __webpack_public_path__ + "img/magento-custom-development_medium.aa520d28.webp";